
import VectorSource from 'ol/source/Vector'
import VectorLayer from 'ol/layer/Vector'
import Style from 'ol/style/Style'
import Feature from 'ol/Feature'
import Point from 'ol/geom/Point'
import Icon from 'ol/style/Icon'
export default
{
  methods:
  {
  //空间分析数据
    getDmkcary(fidary)
    {
      let exp = `gid in (${fidary.toString()})`
      let paras = {cmd: 'query', _major: 11, _minor: 73, _exp: exp, vals: this.Title}
      window.post.getPost(paras).then((ret) =>
      {
        this.tableData = []
        let temp = []
        let tempseries = []
        //加载完成
        this.$parent.loading = false
        ret.forEach(item =>
        {
          this.tableData.push({fid: item.GID, fhh: item.fhh, owner: item.ssgj, scale: item.gm, type: item.type, x: item.GEOM_SDO_POINT_X, y: item.GEOM_SDO_POINT_Y})
          if (temp.indexOf(item.type) === -1)
            temp.push(item.type)
        })
        this.xAxisdata = temp
        temp.forEach(item1 =>
        {
          let num = 0
          ret.forEach(item2 =>
          {
            if (item1 === item2.type)
              num++
          })
          tempseries.push(num)
        })
        this.seriesdata = tempseries
      })
    },
    /**
     * 定位
     */
    positioning(row)
    {
      window.map.getView().animate({ // 只设置需要的属性即可
        center: [row.x, row.y], // 中心点
        zoom: 8, // 缩放级别
        rotation: undefined, // 缩放完成view视图旋转弧度
        duration: 1000 // 缩放持续时间，默认不需要设置
      })
      let coordinate = [row.x, row.y]
      let rome = new Feature({
        geometry: new Point(coordinate) //几何信息
      })
      var vector = new VectorSource()
      vector.addFeature(rome)
      var wfsVectorLayer = new VectorLayer({
        source: vector,
        style: new Style({
          image: new Icon({
            color: '#BADA55',
            crossOrigin: 'anonymous',
            src: '../../../../../static/index/map-marker (1).png'
          })
        })
      })
      this.LayernarData.push(wfsVectorLayer)
      window.map.addLayer(wfsVectorLayer)
    },
    /**
     * echarts图
     */
    drawbar(type)
    {
      let typeName = ''
      switch (type)
      {
      case  'bar': typeName = '柱状图'
        break
      case 'pie' : typeName = '饼图'
        break
      case 'line' : typeName = '折线图'
        break
      }
      let xAxis = []
      let yAxis = []
      let series = []
      let color1 = {
        x: 0,
        y: 0,
        x2: 0,
        y2: 1,
        type: 'linear',
        global: false,
        colorStops: [
          {
            offset: 0,
            color: '#09AADE'
          },
          {
            offset: 1,
            color: '#35D0E9'
          }
        ]
      }
      let color2 = {
        x: 0,
        y: 0,
        x2: 0,
        y2: 1,
        type: 'linear',
        global: false,
        colorStops: [
          {
            offset: 0,
            color: '#0C3FFD'
          },
          {
            offset: 1,
            color: '#3764FC'
          }
        ]
      }
      let color3 = {
        x: 0,
        y: 0,
        x2: 0,
        y2: 1,
        type: 'linear',
        global: false,
        colorStops: [
          {
            offset: 0,
            color: '#5C3CC1'
          },
          {
            offset: 1,
            color: '#9167FC'
          }
        ]
      }
      let color4 = {
        x: 0,
        y: 0,
        x2: 0,
        y2: 1,
        type: 'linear',
        global: false,
        colorStops: [
          {
            offset: 0,
            color: '#F78861'
          },
          {
            offset: 1,
            color: '#E4D682'
          }
        ]
      }
      if (type === 'pie')
      {
        let temp = []
        this.xAxisdata.forEach((item, index) =>
        {
          temp.push({name: item, value: this.seriesdata[index]})
        })
        series = [
          {
            data: temp,
            center: ['55%', '50%'],
            type: type,
            itemStyle: {
              normal: {
                color: function(params)
                {
                  let colorList = []
                  temp.forEach(item =>
                  {
                    colorList.push(color1, color2, color3, color4)
                  })
                  return colorList[params.dataIndex]
                },
                label: {
                  show: true,
                  position: 'outside',
                  color: '#fff',
                  formatter: function(params)
                  {
                    let percent = 0
                    let total = 0
                    for (let i = 0; i < temp.length; i++)
                      total += temp[i].value
                    percent = ((params.value / total) * 100).toFixed(0)
                    if (params.name !== '') return params.name + percent + '%'
                    else return ''
                  }
                },
                labelLine: {
                  length: 10,
                  length2: 10,
                  show: true,
                  color: '#ffffff'
                }
              }
            }
          }
        ]
      }
      else
      {
        xAxis.push({
          data: this.xAxisdata,
          //x轴刻度线颜色
          axisTick: {show: false},
          //x轴横向分割线颜色
          axisLine: {show: true, lineStyle: {color: '#01DFF4'}},
          axisPointer: {type: 'line'},
          splitLine: {show: false},
          axisLabel: {
            interval: 0,
            formatter: function(value)
            {
              return value.split('').join('\n')
            }
          }
        })
        yAxis.push({
          type: 'value',
          name: '数量',
          //轴刻度线颜色
          axisTick: {show: false},
          //轴横向分割线颜色
          axisLine: {show: true, lineStyle: {color: '#01DFF4'}},
          axisPointer: { type: 'line' },
          splitLine: {show: true, lineStyle: {color: '#FFFFFF', opacity: '0.5'}}
        })
        series.push({
          data: this.seriesdata,
          type: type,
          smooth: true,
          itemStyle: {
            normal: {
              color: type === 'bar' ? function(params)
              {
                let colorList = [color1, color2, color3, color4]
                xAxis[0].data.forEach(item =>
                {
                  colorList.push(color1, color2, color3, color4)
                })
                return colorList[params.dataIndex]
              } : '#23fffc',
              label: {
                show: true,
                position: 'top',
                formatter: '{b}:{c}'
              }
            }
          }

        })
      }
      this.$emit('showEcharts', xAxis, yAxis, series, typeName)
    },
    /**
     * 点击导出报表响应
     */
    onClickExpExcel()
    {
      let param =
      {
        json: this.tableData,
        filename: '缓冲区分析报表',
        columns: {
          owner: '国家',
          scale: '规模',
          type: '类型'
        }
      }
      cx.expExcel.exportToExcel(param)
    },
    //表头样式设置
    headercell(row, column, rowIndex, columnIndex)
    {
      return 'background: rgba(35, 134, 135, 0.7) !important;color: #23fffc;'
    },
    //修改表格行样式
    rowstyles({row, rowIndex})
    {
      if (rowIndex % 2 === 1)
      {
        let styleJson = {
          'background': 'rgba(2,36,38, .8) !important'
        }
        return styleJson
      }
      else
      {
        let styleJson = {
          'background': 'rgba(44,74,73, .8) !important'
        }
        return styleJson
      }
    }
  }
}




// WEBPACK FOOTER //
// ./src/plugins/app/assembly/kyyzt/SpaceQuery.js